"use client";

import type { StytchEvent } from "@stytch/vanilla-js";
import { StytchEventType as SEvents } from "@stytch/vanilla-js";
import { useCallback } from "react";
import { reportAttemptedEmailLogin } from "../../lib/analytics";
import { useB2BSignup } from "./use-b2b-signup";
import { useOrganizationDecisionTree } from "./use-organization-decision-tree";

export const useAuthEventHandler = (onAuthComplete: () => Promise<void>) => {
  const { handleSignup, isProcessing } = useB2BSignup();
  const { handleOrganizationSelection } =
    useOrganizationDecisionTree(onAuthComplete);

  const handleAuthEvent = useCallback(
    async (event: StytchEvent) => {
      if (event.type === SEvents.AuthenticateFlowComplete) {
        await onAuthComplete();
      } else if (
        event.type === SEvents.B2BOAuthDiscoveryAuthenticate ||
        event.type === SEvents.B2BMagicLinkDiscoveryAuthenticate
      ) {
        if (event.type === SEvents.B2BMagicLinkDiscoveryAuthenticate) {
          reportAttemptedEmailLogin(event.data.email_address);
        }

        if (event.data.discovered_organizations.length === 0) {
          await handleSignup(event.data.intermediate_session_token);
        } else {
          // Use the new decision tree for organization selection
          await handleOrganizationSelection(
            event.data.discovered_organizations,
          );
        }
      }
    },
    [onAuthComplete, handleSignup, handleOrganizationSelection],
  );

  return { handleAuthEvent, isProcessing } as const;
};
